import React from 'react';
import FormHandler from '../FormHandler';
import { Stack } from '@mui/material';
import CodeInput from './CodeInput';
import Typography from '@mui/material/Typography';
import { Email } from '../styledComponents';
import Button from '@mui/material/Button';
import { useUsername } from '../../slices/hooks/useUsersSlice';

interface Props {
    show: boolean;
    code: string;
    setCode: (code: string) => void;
    isLoading: boolean;
    verifyContactCode: (code: string) => void;
    onReset: () => void;
}
const VerifyCode = ({ show, code, setCode, isLoading, verifyContactCode, onReset }: Props) => {
    const { username: email } = useUsername();
    if (!show) {
        return <></>;
    }

    const handleFormSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        verifyContactCode(code);
    };

    const handleSetCode = (newCode: string) => {
        setCode(newCode);
        verifyContactCode(newCode);
    };

    return (
        <>
            <Typography variant="h5" mb="25px" gutterBottom style={{ textAlign: 'center' }}>
                Enter the 6-digit code we sent to your email
                <Email mt="10px">{email}</Email>
                <Button onClick={() => onReset()}>Not you?</Button>
            </Typography>
            <FormHandler
                onSubmit={handleFormSubmit}
                buttonText="Verify"
                isDisabled={isLoading}
                isLoading={isLoading}
            >
                <Stack
                    direction="row"
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <CodeInput onComplete={handleSetCode} />
                </Stack>
            </FormHandler>
        </>
    );
};
export default VerifyCode;
